module.exports = __webpack_public_path__ + "static/media/kitchen4.87ec37bc.jpg";